import React, { Suspense, lazy } from 'react';
import { Modal, Tooltip, OverlayTrigger, Button, FormGroup, Row, Col } from 'react-bootstrap';
import WSManager from "../WSHelper/WSManager";
import * as WSC from "../WSHelper/WSConstants";
import * as AppLabels from "../helper/AppLabels";
import { inputStyle } from '../helper/input-style';
import { MyContext } from '../InitialSetup/MyProvider';
import { Utilities } from '../Utilities/Utilities';
import { getUserBalance, validateContestPromo } from '../WSHelper/WSCallings';
import * as Constants from "../helper/Constants";
import Images from "../components/images";
var UserBalance = null;
var discountAmount = 0;
var entryFeeAfterDiscount = 0;

export default class ConfirmationPopup extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedTeam: '',
            Teams: this.props.TeamListData,
            TotalTeam: this.props.TotalTeam,
            FixturedContestItem: this.props.FixturedContest,
            lobbyDataItem: this.props.lobbyDataToPopup,
            mUserBalance: '',
            balanceAccToMaxPercent: "",
            promoCode: '',
            benefitCap: '',
            entryFeeAfterPromoCode: "",
            isDisabled: false,
            lineUpMasterIdOfCreatedTeam: this.props.createdLineUp != "" ? this.props.createdLineUp : "",
            lineUpMasterIdArray: this.props.selectedLineUps ? this.getSelectedLinups(this.props.selectedLineUps, this.props.FixturedContest.contest_id) : [],
            TeamsSortedArray: [],
            isChanged: true,
            refreshAddFundsBtn: true,
            entryFeeOfContest: this.props.FixturedContest.entry_fee,
            showPromoCode: false,
            clickOnce: false,
            promoCodeErrorMsg: '',
            contestMaxBonusAllowed: '',
            useWinningAmt: false,
            BalanceDetail: Utilities.getBalanceInDetail(this.props.FixturedContest.entry_fee),
            AmountToAdd: parseFloat(this.props.FixturedContest.entry_fee),
            refreshField: true,
            isLoading: false,
            isCMounted: false,
        };


    }


    // getSelectedLinups(selectedLineUps, contest_id) {
    //     return selectedLineUps.filter((elem) => {
    //         if (elem.joined_contests && elem.joined_contests.indexOf(contest_id) > -1) {
    //             return false
    //         }
    //         return true;
    //     })
    // }

    getSelectedLinups(selectedLineUps, contest_id) {        
        const linupMasterIds = selectedLineUps.map(value => value.lineup_master_id).join(',');
        console.log(linupMasterIds,'linupMasterIds');
        return this.props.TotalTeam.map(team=>{
            return linupMasterIds.indexOf(team.lineup_master_id) > -1 ? team : null;
        }).filter(elem => {
            if(!elem || elem.joined_contests && elem.joined_contests.indexOf(contest_id) > -1) return false;
           return true;
        })
    }

    fiterCreatedTeamFromAllTeams(TeamListData) {
        if (this.state.lineUpMasterIdOfCreatedTeam != "") {

            let teamList1 = [];
            for (var obj of TeamListData) {

                let tempObj = {};
                tempObj['label'] = obj.label ? obj.label : obj.team_name;
                tempObj['value'] = obj.value ? obj.value : obj;

                if (this.state.lineUpMasterIdOfCreatedTeam == tempObj.value.lineup_master_id) {
                    teamList1.push(tempObj)
                    this.setState({ selectedTeam: tempObj })

                } else {
                    teamList1.push(tempObj)

                }
            }
            if (teamList1.length == 1) {
                this.setState({
                    TeamsSortedArray: teamList1.reverse(),
                    Teams: teamList1,
                    selectedTeam: teamList1[0]
                })
            } else {
                this.setState({
                    TeamsSortedArray: teamList1.reverse(),
                    Teams: teamList1
                })
            }


        } else {
            if (this.props.TeamListData.length > 1) {
                if (this.props.TeamListData[0].lineup_master_id > this.props.TeamListData[1].lineup_master_id) {
                    this.setState({ TeamsSortedArray: this.props.TeamListData.reverse() })
                } else {
                    this.setState({ TeamsSortedArray: this.props.TeamListData })
                }
            } else {
                if (this.props.TeamListData.length == 1) {
                    this.setState({ TeamsSortedArray: this.props.TeamListData, selectedTeam: this.props.TeamListData[0] })
                } else {
                    this.setState({ TeamsSortedArray: this.props.TeamListData })
                }
            }

        }
    }


    handleTeamChange = (selectedOption) => {
        if (selectedOption.value == AppLabels.CREATE_NEW_TEAM) {
            this.props.CreateTeamClickEvent(this.props.FixturedContest, this.state.lobbyDataItem)
        }
        this.setState({ selectedTeam: selectedOption })
    }

    ShowPromoCode = () => {
        this.setState({
            showPromoCode: true
        })
    }

    userBalance(EntryFee, maxBonusAllowed) {
        if (this.state.FixturedContestItem.currency_type != 2 && maxBonusAllowed != null && maxBonusAllowed != "") {
            UserBalance = Utilities.getMaxBonusAllowedOfEntryFeeContestWise(EntryFee, maxBonusAllowed);
        }
        else if (this.state.FixturedContestItem.currency_type == 2) {
            UserBalance = this.state.mUserBalance.point_amount
        }
        else {
            UserBalance = Utilities.getBalanceAccToMaxPercentOfEntryFee(EntryFee);
        }

        this.setState({
            refreshAddFundsBtn: false,
            entryFeeOfContest: EntryFee
        })

        setTimeout(() => {
            this.setState({
                balanceAccToMaxPercent: UserBalance,
                refreshAddFundsBtn: true
            })
        }, 100);
    }

    componentDidMount() {
        const { TeamsSortedArray } = this.state
        this.handelBycoinAppEvent()
        var allowedBonusPercantage = WSManager.getAllowedBonusPercantage()
        var BonusAllowed = parseFloat(allowedBonusPercantage) * parseFloat(this.state.FixturedContestItem.entry_fee) / 100
        this.setState({
            contestMaxBonusAllowed: BonusAllowed
        })

        this.callUserBalanceApi();
        this.fiterCreatedTeamFromAllTeams(this.props.TeamListData);
        if (this.props.TotalTeam.length == 1) {
            this.setState({
                lineUpMasterIdArray: [this.props.TotalTeam[0]],
                isCMounted: true
            });
        } else {
            this.setState({
                isCMounted: true
            });
        }
    }


    callUserBalanceApi() {

        getUserBalance().then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                this.setState({
                    mUserBalance: responseJson.data.user_balance
                })
                WSManager.setAllowedBonusPercantage(responseJson.data.allowed_bonus_percantage)
                WSManager.setBalance(responseJson.data.user_balance);
                this.userBalance(this.state.FixturedContestItem.entry_fee, this.state.FixturedContestItem.max_bonus_allowed)

            } else {
                this.props.IsConfirmationPopupHide()
            }
        })
    }

    callGetPromoCodeDetailApi(inputPromoCode) {

        if (!this.state.isLoading) {
            this.setState({
                isLoading: true
            })
            let param = {
                "promo_code": inputPromoCode,
                "contest_id": this.state.FixturedContestItem.contest_id
            }

            validateContestPromo(param).then((responseJson) => {
                this.setState({
                    isLoading: false
                })
                if (responseJson.response_code == WSC.successCode) {
                    Utilities.showToast(AppLabels.Promocode_has_been_applied, 2500);
                    this.setState({
                        benefitCap: responseJson.data.benefit_cap,
                        isDisabled: true
                    }, () => {
                        this.hidePromoCode()
                    })
                    this.entryFeeAccToBenefitCapOrDiscount(responseJson.data.amount, this.state.benefitCap);
                }
                else {
                    this.setState({
                        promoCodeErrorMsg: responseJson.message
                    })
                }
            })
        }
    }

    removePromoCode() {
        this.userBalance(this.state.FixturedContestItem.entry_fee, this.state.FixturedContestItem.max_bonus_allowed)
        this.setState({
            entryFeeAfterPromoCode: "",
            promoCode: "",
            isChanged: false,
            isDisabled: false,
            showPromoCode: false,
        },
            () => {
                this.setState({
                    BalanceDetail: Utilities.getBalanceInDetail(this.state.FixturedContestItem.entry_fee)
                })
            }
        )

        setTimeout(() => {
            this.setState({
                isChanged: true
            })
        }, 100);
    }

    handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });
    }

    entryFeeAccToBenefitCapOrDiscount(mDiscountAmount, mBenefitCap) {

        discountAmount = mDiscountAmount;
        entryFeeAfterDiscount = parseFloat(this.state.FixturedContestItem.entry_fee) - parseFloat(discountAmount);
        if (entryFeeAfterDiscount < 0)
            entryFeeAfterDiscount = 0;

        this.setState({
            entryFeeAfterPromoCode: entryFeeAfterDiscount == 0 ? "0" : entryFeeAfterDiscount
        },
            () => {
                this.setState({
                    BalanceDetail: Utilities.getBalanceInDetail(entryFeeAfterDiscount)
                })
            })

        this.userBalance(entryFeeAfterDiscount, this.state.FixturedContestItem.max_bonus_allowed)
    }

    UseWinning = () => {
        this.setState({
            useWinningAmt: !this.state.useWinningAmt
        })
    }

    showPromoCode = () => {
        this.setState({
            showPromoCode: true
        })
    }
    hidePromoCode = () => {
        this.setState({
            showPromoCode: false
        })
    }
    PromoCodeFn = (event) => {
        event.stopPropagation()
    }

    addAmount = (amt) => {
        let totalAmt = this.state.AmountToAdd;
        totalAmt = parseFloat(totalAmt + amt);
        this.setState({
            AmountToAdd: totalAmt,
            refreshField: false
        }, () => {
            this.setState({
                refreshField: true
            })
        })
    }

    onChange = (e) => {
        let amt = e.target.value;
        this.setState({
            AmountToAdd: amt
        })
    }

    goToBuyCoins = () => {

        if (window.ReactNativeWebView) {
            let data = {
                action: 'openBuyScreen',
                targetFunc: 'openBuyScreen',
            }
            window.ReactNativeWebView.postMessage(JSON.stringify(data));
        } else {
            this.props.showDownloadApp();
        }

    }
    handelBycoinAppEvent() {
        window.addEventListener('message', (e) => {
            if (e.data.action == 'buyCoin' && e.data.type == 'succuss') {
                this.callUserBalanceApi();
            }
        });
    }

    selectLinupClick(lineUpMasterIdArray, team) {
        if (this.state.FixturedContestItem.multiple_lineup > 1) {

            this.setState({ lineUpMasterIdArray: [...lineUpMasterIdArray, team] })
        } else {
            this.setState({ lineUpMasterIdArray: [team] })
        }
    }

    populateTeamsForPopUp = (TotalTeam, lineUpMasterIdArray) => {
        let teams = []
        if (TotalTeam.length == 1) {
            const isAreadyJoined = TotalTeam[0].joined_contests && TotalTeam[0].joined_contests.indexOf(this.state.FixturedContestItem.contest_id) > -1;
            teams.push(
                <div className={`${isAreadyJoined ? 'team-container team-disabled' : "team-container-selected"}`}>
                    <div className="team-header">
                        <div>
                            {TotalTeam[0].team_name}
                        </div>
                        {isAreadyJoined ? <div className="contests-joined">
                            Already Joined
                        </div> : <div className="contests-joined">
                            {TotalTeam[0].total_joined} {AppLabels.CONTEST_JOINED}
                        </div>}
                    </div>
                    <div className="team-content" >
                        <div className="player-content">
                            <div className="c-icon">C</div>
                            <div style={{ marginLeft: 10 }}>
                                <div>
                                    {TotalTeam[0].c_name}
                                </div>
                                <div>
                                    {TotalTeam[0].c_position} | {TotalTeam[0].c_team}
                                </div>
                            </div>
                        </div>
                        <div className="player-content">
                            <div className="vc-icon">VC</div>
                            <div style={{ marginLeft: 10 }}>
                                <div>
                                    {TotalTeam[0].vc_name}
                                </div>
                                <div>
                                    {TotalTeam[0].vc_position} | {TotalTeam[0].vc_team}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            for (let i = 0; i < TotalTeam.length; i++) {
                const isAreadyJoined = TotalTeam[i].joined_contests && TotalTeam[i].joined_contests.indexOf(this.state.FixturedContestItem.contest_id) > -1;
                if (lineUpMasterIdArray.some(el => el.lineup_master_id === TotalTeam[i].lineup_master_id) && !isAreadyJoined) {
                    teams.push(
                        <div onClick={() => this.setState({ lineUpMasterIdArray: this.state.lineUpMasterIdArray.filter(function (team) { return team.lineup_master_id !== TotalTeam[i].lineup_master_id }) })} className="team-container-selected">
                            <div className="team-header">
                                <div>
                                    {TotalTeam[i].team_name}
                                </div>
                                <div className="contests-joined">
                                    {TotalTeam[i].total_joined} {AppLabels.CONTEST_JOINED}
                                </div>
                            </div>
                            <div className="team-content">
                                <div className="player-content">
                                    <div className="c-icon">C</div>
                                    <div style={{ marginLeft: 10 }}>
                                        <div>
                                            {TotalTeam[i].c_name}
                                        </div>
                                        <div>
                                            {TotalTeam[i].c_position} | {TotalTeam[i].c_team}
                                        </div>
                                    </div>
                                </div>
                                <div className="player-content">
                                    <div className="vc-icon">VC</div>
                                    <div style={{ marginLeft: 10 }}>
                                        <div>
                                            {TotalTeam[i].vc_name}
                                        </div>
                                        <div>
                                            {TotalTeam[i].vc_position} | {TotalTeam[i].vc_team}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    teams.push(
                        <div onClick={() => this.selectLinupClick(this.state.lineUpMasterIdArray, TotalTeam[i])} className={`team-container ${isAreadyJoined ? 'team-disabled' : ''}`} >
                            <div className="team-header">
                                <div>
                                    {TotalTeam[i].team_name}
                                </div>
                                {isAreadyJoined ? <div className="contests-joined">
                                    Already Joined
                                </div> : <div className="contests-joined">
                                    {TotalTeam[i].total_joined} {AppLabels.CONTEST_JOINED}
                                </div>}
                            </div>
                            <div className="team-content">
                                <div className="player-content">
                                    <div className="c-icon">C</div>
                                    <div style={{ marginLeft: 10 }}>
                                        <div>
                                            {TotalTeam[i].c_name}
                                        </div>
                                        <div>
                                            {TotalTeam[i].c_position} | {TotalTeam[i].c_team}
                                        </div>
                                    </div>
                                </div>
                                <div className="player-content">
                                    <div className="vc-icon">VC</div>
                                    <div style={{ marginLeft: 10 }}>
                                        <div>
                                            {TotalTeam[i].vc_name}
                                        </div>
                                        <div>
                                            {TotalTeam[i].vc_position} | {TotalTeam[i].vc_team}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            }
        }
        return teams
    }

    render() {
        const {
            selectedTeam,
            FixturedContestItem,
            mUserBalance,
            balanceAccToMaxPercent,
            promoCode,
            entryFeeAfterPromoCode,
            isDisabled,
            lineUpMasterIdOfCreatedTeam,
            TeamsSortedArray,
            isChanged,
            refreshAddFundsBtn,
            entryFeeOfContest,
            clickOnce,
            lineUpMasterIdArray,
            isCMounted
        } = this.state;

        let EntryFee = this.state.TotalTeam.length == 1 ? FixturedContestItem.entry_fee : this.props.fromMyTeams ? FixturedContestItem.entry_fee : FixturedContestItem.entry_fee * lineUpMasterIdArray.length
        let CurrencyType = FixturedContestItem.currency_type
        let isNetworkFantasyContest = FixturedContestItem && FixturedContestItem.is_network_contest && FixturedContestItem.is_network_contest == 1 ? true : false

        const { ConfirmationClickEvent, FixturedContest } = this.props;
        let maxCBCapAmount = Utilities.getMasterData().max_contest_bonus;
        return (
            <MyContext.Consumer>
                {(context) => (

                    //Old Confirmation modal
                    <Modal
                        show={this.props.IsConfirmationPopupShow}
                        onHide={this.props.IsConfirmationPopupHide}
                        dialogClassName="custom-modal thank-you-modal confirmation-modal confirmation-modal-contestlist "
                        className="center-modal"
                    >
                        <Modal.Header>
                            <div className='Confirm-header '>
                                {AppLabels.CONFIRMATION}
                            </div>
                        </Modal.Header>

                        <Modal.Body>
                            {
                                mUserBalance &&
                                <React.Fragment>
                                    <Row className='mt30' style={{ padding: 0 }}>
                                        {
                                            Constants.SELECTED_GAMET != Constants.GameType.Free2Play &&
                                            <Col xs={12} style={{ padding: 0 }}>

                                                <div className={"fee-container" + (balanceAccToMaxPercent < EntryFee ? ' fee-container-danger' : '')}>
                                                    <div className="lable-text">{CurrencyType == 2 ? AppLabels.PAYABLE_COINS_BAL : AppLabels.PAYABLE_BALANCE}
                                                        {
                                                            CurrencyType != 2 &&

                                                            <OverlayTrigger trigger={'click'} placement="bottom" overlay={
                                                                <Tooltip id="tooltip">
                                                                    <strong>{AppLabels.PAYABLE_TOOLTIP1
                                                                        + (FixturedContest.max_bonus_allowed != null && FixturedContest.max_bonus_allowed != "" ? FixturedContest.max_bonus_allowed : WSManager.getAllowedBonusPercantage()) + AppLabels.PAYABLE_TOOLTIP2 + (maxCBCapAmount > 0 ? (' (' + AppLabels.MAX + " " + Utilities.getMasterData().currency_code + maxCBCapAmount + ')') : '')}</strong>
                                                                </Tooltip>
                                                            }>
                                                                <i className="icon-info m-l-sm"></i>
                                                            </OverlayTrigger>
                                                        }

                                                    </div>
                                                    <div className="payable-amount-value">
                                                        <span className='confirmation'>
                                                            {
                                                                CurrencyType == 2 ?
                                                                    <span
                                                                        // style={{ fontSize: ((JSON.stringify(FixturedContestItem.point_amount).length) > 5 ? 14 : 14) }} 
                                                                        className={balanceAccToMaxPercent < EntryFee ? ' ' : ''}>
                                                                        <img className="img-coin" alt='' src={Images.IC_COIN} />
                                                                        {parseInt(balanceAccToMaxPercent)}
                                                                    </span>
                                                                    :
                                                                    <span
                                                                        // style={{ fontSize: ((JSON.stringify(balanceAccToMaxPercent).length) > 5 ? 14 : 14) }}
                                                                        className={balanceAccToMaxPercent < EntryFee ? ' ' : ''}>
                                                                        {Utilities.getMasterData().currency_code}{parseInt(balanceAccToMaxPercent).toFixed(2)}
                                                                    </span>
                                                            }
                                                        </span>
                                                        {/* {
                                                        Constants.SELECTED_GAMET != Constants.GameType.Free2Play &&
                                                        <>
                                                        {
                                                            CurrencyType == 2 ?
                                                            <img className="img-coin" alt='' src={Images.IC_COIN} />
                                                            :
                                                            Utilities.getMasterData().currency_code
                                                        }
                                                        </>
                                                    }
                                                    {Constants.SELECTED_GAMET == Constants.GameType.Free2Play ? AppLabels.FREE : entryFeeAfterPromoCode == "" ? EntryFee : entryFeeAfterPromoCode}</span> */}

                                                    </div>
                                                </div>
                                                <div className='devider-line'></div>

                                            </Col>
                                        }

                                        <Col xs={12} style={{ padding: 0 }}>
                                            <div className="fee-container">
                                                <div className='lable-text'>{AppLabels.ENTRY_FEE}</div>
                                                <div className="payable-amount-value">
                                                    {/* {
                                                        CurrencyType == 2 ?
                                                            <span 
                                                                // style={{ fontSize: ((JSON.stringify(FixturedContestItem.point_amount).length) > 5 ? 14 : 14) }} 
                                                                className={balanceAccToMaxPercent < EntryFee ? ' ' : ''}> 
                                                                <img className="img-coin" alt='' src={Images.IC_COIN} />
                                                                {parseInt(balanceAccToMaxPercent)}
                                                            </span>
                                                        :
                                                        <span 
                                                            // style={{ fontSize: ((JSON.stringify(balanceAccToMaxPercent).length) > 5 ? 14 : 14) }}
                                                            className={balanceAccToMaxPercent < EntryFee ? ' ' : ''}> 
                                                                {Utilities.getMasterData().currency_code}{parseInt(balanceAccToMaxPercent).toFixed(2)}
                                                            </span>
                                                    } */}
                                                    <span>
                                                        {
                                                            Constants.SELECTED_GAMET != Constants.GameType.Free2Play &&
                                                            <>
                                                                {
                                                                    CurrencyType == 2 ?
                                                                        <img className="img-coin" alt='' src={Images.IC_COIN} />
                                                                        :
                                                                        Utilities.getMasterData().currency_code
                                                                }
                                                            </>
                                                        }
                                                        {Constants.SELECTED_GAMET == Constants.GameType.Free2Play ? AppLabels.FREE : entryFeeAfterPromoCode == "" ? EntryFee : entryFeeAfterPromoCode}</span>
                                                </div>
                                            </div>
                                            <div className='devider-line'></div>
                                        </Col>
                                    </Row>
                                    <Row style={{ padding: 2 }}>
                                        <Col xs={12} style={{ padding: "10px 0" }}>
                                            {this.state.TotalTeam.length > 0 ?
                                                <div style={{ paddingLeft: 10, paddingRight: 10 }}>                                                 
                                                    <div style={{ textAlign: 'center' }}>
                                                        {AppLabels.JOINING_CONTEST_WITH} <span style={{ fontWeight: 'bold' }}>{this.state.TotalTeam.length == 1 ? 1 : lineUpMasterIdArray.length} {AppLabels.TEAMS2}</span>
                                                    </div>
                                                    <div style={{ maxHeight: 300, overflowY: 'scroll' }}>
                                                        {this.populateTeamsForPopUp(this.state.TotalTeam, lineUpMasterIdArray)}
                                                    </div>
                                                </div>
                                                :
                                                <div className="fee-container">
                                                    {this.state.TotalTeam.length}
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                    {/*<Row style={{ padding: 2 }}>
                                        <Col xs={12} style={{ padding: "10px 0"  }}>
                                            {lineUpMasterIdArray.length > 1 ? 
                                            <><div className="fee-container">
                                            <div className='lable-text'>{AppLabels.JOINING_TEAM_WITH.replace(AppLabels.Team,'')}</div>
                                            <div className="payable-amount-value">
                                                <span>
                                                {lineUpMasterIdArray.length + " " + AppLabels.Teams}
                                                </span>
                                            </div>
                                        </div><div className='devider-line'></div></>
                                        :
                                            <><div className="fee-container ">
                                                <div className="lable-text small-div">{AppLabels.JOINING_TEAM_WITH}</div>
                                                <div className="joining-team">
                                                    {
                                                        this.state.TotalTeam.length < parseInt(Utilities.getMasterData().a_teams) ?
                                                        isCMounted && <Suspense fallback={<div />} ><ReactSelectDD
                                                                onChange={this.handleTeamChange}
                                                                options={lineUpMasterIdOfCreatedTeam != "" ? TeamsSortedArray : [...[{ label: AppLabels.CREATE_NEW_TEAM, value: AppLabels.CREATE_NEW_TEAM }], ...TeamsSortedArray]}
                                                                className={"basic-select-field" + (lineUpMasterIdOfCreatedTeam != "" ? '' : ' add-create-team')}
                                                                classNamePrefix="select"
                                                                value={TeamsSortedArray.length == 1 ? TeamsSortedArray[0] : selectedTeam}
                                                                placeholder={AppLabels.SELECT_TEAM}
                                                                isSearchable={false}
                                                                isClearable={false}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    borderRadius: 0,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#fff',
                                                                        primary: '#555555',
                                                                    },
                                                                })}
                                                            /></Suspense>
                                                            :
                                                            isCMounted && <Suspense fallback={<div />} ><ReactSelectDD
                                                                onChange={this.handleTeamChange}
                                                                options={TeamsSortedArray}
                                                                className="basic-select-field"
                                                                classNamePrefix="select"
                                                                value={TeamsSortedArray.length == 1 ? TeamsSortedArray[0] : selectedTeam}
                                                                placeholder={AppLabels.SELECT_TEAM}
                                                                isSearchable={false} isClearable={false}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    borderRadius: 0,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#fff',
                                                                        primary: '#555555',
                                                                    },
                                                                })}
                                                            /></Suspense>
                                                    }
                                                </div>
                                            </div>
                                            <div className='devider-line no-margin'></div>
                                                </>}
                                        </Col>
                                    </Row>*/}
                                    {(CurrencyType != 2 && EntryFee > 0 && !this.state.showPromoCode && lineUpMasterIdArray.length <= 1) &&
                                        this.ShowPromoCode()
                                    }
                                </React.Fragment>



                            }
                            {/* {CurrencyType != 2 && EntryFee > 0 && this.state.showPromoCode && !isNetworkFantasyContest &&
                                <div >
                                    <FormGroup
                                        className='input-label-center input-with-cancel'
                                        controlId="formBasicText"
                                    >
                                        {promoCode != '' && <label className="input-label">{AppLabels.ENTER_PROMO_CODE}</label>}
                                        <span className="promocode-input">
                                            {
                                                isChanged ? <input
                                                    id='promoCode'
                                                    name='promoCode'
                                                    placeholder={AppLabels.ENTER_PROMO_CODE}
                                                    type='text'
                                                    value={promoCode}
                                                    maxLength={10}
                                                    onChange={this.handleChange}
                                                    disabled={isDisabled}
                                                /> : <div className='input-label-center input-with-cancel'
                                                    styles={inputStyle}
                                                    />
                                            }
                                            {isDisabled &&
                                                <i onClick={() => this.removePromoCode()} className="icon-close"></i>
                                            }
                                        </span>

                                    </FormGroup>
                                    {
                                        !isNetworkFantasyContest &&
                                        <div className="text-center">
                                        <Button disabled={promoCode.length < 4 ? true : false} onClick={() => this.callGetPromoCodeDetailApi(promoCode)} className="btn btn-success btn-rounded promo-btn">{AppLabels.APPLY}</Button>
                                    </div>
                                    }
                                    
                                </div>}
                            <div className="text-center promocode-congrats">
                                {isDisabled &&
                                    <React.Fragment>
                                        {AppLabels.PROMO_TEXT1} 
                                        <span className="teal-color text-bold">
                                            {Utilities.getMasterData().currency_code}
                                            {(parseFloat(EntryFee) - parseFloat(entryFeeAfterPromoCode)).toFixed(2)}
                                        </span> 
                                        {AppLabels.PROMO_TEXT2} 
                                        <span className="teal-color text-bold">
                                            {Utilities.getMasterData().currency_code}{entryFeeAfterPromoCode}
                                        </span>.
                                        </React.Fragment>
                                }
                                {!isDisabled &&
                                    <React.Fragment>
                                        <span className="text-danger">
                                            {this.state.promoCodeErrorMsg}
                                        </span>
                                    </React.Fragment>
                                }
                            </div> */}

                        </Modal.Body>
                        <Modal.Footer className='custom-modal-footer dual-btn-footer'>
                            {refreshAddFundsBtn &&
                                <a href className={"joinContestConfirm single-text" + (clickOnce && selectedTeam != '' ? ' click-disabled' : '')} onClick={() => {
                                    this.setState({ clickOnce: selectedTeam != '' }, () => {
                                        if (Constants.OnlyCoinsFlow == 1 || Constants.OnlyCoinsFlow == 2) {
                                            var currentEntryFee = 0;
                                            currentEntryFee = this.state.entryFeeOfContest;
                                            if (
                                                (FixturedContestItem.currency_type == 2 && (parseInt(currentEntryFee) <= parseInt(balanceAccToMaxPercent))) ||
                                                (FixturedContestItem.currency_type != 2 && (parseFloat(currentEntryFee) <= parseFloat(balanceAccToMaxPercent)))
                                            ) {
                                                ConfirmationClickEvent(this.state, context);

                                            }
                                            else {
                                                if (FixturedContestItem.currency_type == 2) {
                                                    if (Constants.EnableBuyCoin) {
                                                        this.goToBuyCoins()
                                                    }
                                                }
                                                else {
                                                    ConfirmationClickEvent(this.state, context);

                                                }
                                            }

                                        }
                                        else {
                                            ConfirmationClickEvent(this.state, context);

                                        }
                                        setTimeout(() => {
                                            this.setState({ clickOnce: false })
                                        }, 3000);

                                    });
                                }}>
                                    {
                                        ((CurrencyType != 2 && (parseFloat(balanceAccToMaxPercent) >= parseFloat(entryFeeOfContest)))
                                            ||
                                            (CurrencyType == 2 && (parseInt(balanceAccToMaxPercent) >= parseInt(entryFeeOfContest)))) ?
                                            AppLabels.JOIN_CONTEST :
                                            Constants.SELECTED_GAMET != Constants.GameType.Free2Play ?
                                                (CurrencyType == 2 ? AppLabels.ADD_COIN_AND_JOIN_CONTEST : AppLabels.ADD_FUND_JOIN_CONTEST)
                                                :
                                                AppLabels.JOIN_CONTEST
                                    }

                                </a>
                            }
                        </Modal.Footer>
                    </Modal>

                )}
            </MyContext.Consumer>
        );
    }
}